<div [class.loader-hidden]="show" class="step">
    <div class="loader-overlay">
        <div>
            <mat-progress-bar mode="indeterminate" color="warn"></mat-progress-bar>
        </div>
    </div>
</div>